<script>
import { mapGetters } from 'vuex'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import { updateDispatchStatus } from '@/api/cars'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-feature-select': FeatureSelect,
    'mia-feature-textarea': FeatureTextarea,
    'mia-submit-button': SubmitButton
  },

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data: () => ({
    showUpdateDispatchModal: false,
    form: {
      item_dispatch_status: '',
      item_dispatch_status_comment: ''
    }
  }),

  computed: {
    ...mapGetters(['carDispatchStatus']),

    dispatchStatusLabel() {
      if (!this.row.item_dispatch_status) {
        return ''
      }

      const dispatchStatus = this.carDispatchStatus.find(status => status.id === this.row.item_dispatch_status)

      return dispatchStatus ? dispatchStatus.label : ''
    }
  },

  created() {
    this.$store.dispatch('loadDispatchStatus')

    this.$set(this.form, 'item_dispatch_status', this.row.item_dispatch_status || '')
    this.$set(this.form, 'item_dispatch_status_comment', this.row.item_dispatch_status_comment || '')
  },

  methods: {
    async updateStatus() {
      this.$wait.start('updating dispatch status')
      const [error] = await updateDispatchStatus(this.row.id, this.form)
      this.$wait.end('updating dispatch status')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Auslieferungsstatus konnte nicht aktualisiert werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Auslieferungsstatus erfolgreich aktualisiert']
      })
      this.showUpdateDispatchModal = false
      this.row.item_dispatch_status = this.form.item_dispatch_status
      this.row.item_dispatch_status_comment = this.form.item_dispatch_status_comment
    }
  }
}
</script>

<template>
  <div>
    <div
      v-if="row.item_dispatch_status"
      class="whitespace-no-wrap mb-2"
    >
      {{ dispatchStatusLabel }}
    </div>
    <div
      v-if="row.item_dispatch_status_comment"
      class="mb-2"
    >
      {{ row.item_dispatch_status_comment }}
    </div>
    <div class="whitespace-no-wrap">
      <button
        type="button"
        class="text-orange-mia hover:underline focus:outline-none"
        @click="showUpdateDispatchModal = true"
      >
        Status aktualisieren
      </button>
    </div>

    <mia-modal
      v-if="showUpdateDispatchModal"
      :id="`car-update-dispatch-status-modal-${row.id}`"
      classes="v--modal flex flex-col"
      width="40%"
      height="auto"
      :show="true"
      @closed="showUpdateDispatchModal = false"
    >
      <mia-modal-header>
        <h3 class="py-0 my-0">
          Auslieferungsstatus aktualisieren
        </h3>
      </mia-modal-header>

      <div class="p-4 grid grid-cols-1 gap-6">
        <mia-feature-select
          v-if="carDispatchStatus.length > 0"
          v-model="form.item_dispatch_status"
          label="Status"
          :options="carDispatchStatus"
          name-by="label"
          track-by="id"
        />

        <mia-feature-textarea
          v-model="form.item_dispatch_status_comment"
          label="Kommentar"
        />
      </div>

      <mia-modal-footer class="flex justify-end">
        <mia-cancel-button
          label="Abbrechen"
          size="small"
          :disabled="$wait.is('updating dispatch status')"
          @click="showUpdateDispatchModal = false"
        />
        <mia-submit-button
          label="Speichern"
          class="ml-3"
          size="small"
          :disabled="$wait.is('updating dispatch status')"
          :is-loading="$wait.is('updating dispatch status')"
          @click="updateStatus"
        />
      </mia-modal-footer>
    </mia-modal>
  </div>
</template>
